import React from 'react';

import { Carousel, Tabs } from 'antd/es';

import SliderButtons from '@app/components/LocalCommon/SliderButtons/SliderButtons';
import { CreationStorySlide } from '@app/components/Pages/AboutUs/AboutUs';
import '@app/scss/components/creationStorySlider.scss';

interface CreationStorySlider {
	slides: Array<CreationStorySlide>;
	navCollapse: boolean;
}

const CreationStorySlider: React.FC<CreationStorySlider> = ({ slides, navCollapse }) => {
	const [currentIndex, setCurrentIndex] = React.useState('0');
	const [prevIndex, setPrevIndex] = React.useState(0);
	const [tabIndex, setTabIndex] = React.useState(0);
	const slider = React.useRef<any>();
	const { TabPane } = Tabs;

	const adjustDateTab = () => {
		const tabList = document.querySelector('.creation-story-slider__mobile-nav .ant-tabs-nav-list');
		const style = tabList && tabList.getAttribute('style');
		const xtransit = style && style.substring(style.lastIndexOf('(') + 1, style.lastIndexOf(',')).slice(0, -2);
		if (xtransit !== '0') {
			prevIndex < +currentIndex
				? tabList && tabList.setAttribute('style', `transform: translate(${xtransit && Number(xtransit) - 32}px, 0px) !important;`)
				: tabList && tabList.setAttribute('style', `transform: translate(${xtransit && Number(xtransit) + 32}px, 0px) !important;`);
		}
	};

	React.useEffect(() => {
		setTimeout(() => {
			adjustDateTab();
		}, 500);
	}, [currentIndex]);

	return (
		<div className="creation-story-slider__wrapper">
			<div className="creation-story-slider">
				<h4 className="creation-story-slider__title">Creation story</h4>
				{navCollapse && (
					<div className="creation-story-slider__mobile-nav">
						<Tabs
							className="creation-story-slider__mobile-nav"
							defaultActiveKey="0"
							onTabClick={(key, event) => {
								setCurrentIndex(key);
								slider.current.goTo(key);
							}}
							activeKey={currentIndex}
						>
							{slides.map((item, index) => {
								return <TabPane tab={item.year} key={index.toString()} />;
							})}
						</Tabs>
					</div>
				)}
				<div className="creation-story-slider__main-slider">
					<Carousel
						afterChange={(current) => {
							setCurrentIndex(current.toString());
						}}
						beforeChange={(from, to) => {
							setPrevIndex(from);
						}}
						infinite
						ref={slider}
						dots={false}
					>
						{slides.map((item, index) => (
							<div key={index} className="creation-story-slider__slide">
								<h2 className="creation-story-slider__slide-year">{item.year}</h2>
								<h3 className="creation-story-slider__slide-title">{item.title}</h3>
								<p className="creation-story-slider__slide-message">{item.message}</p>
							</div>
						))}
					</Carousel>
				</div>
				<SliderButtons slider={slider} />
			</div>
			<ul className="creation-story-slider__nav">
				{slides.map((item, index) => (
					<li
						key={index}
						onClick={() => {
							slider.current.goTo(index);
							setCurrentIndex(index.toString());
						}}
						className={+currentIndex === index ? 'creation-story-slider__nav-tab active' : 'creation-story-slider__nav-tab'}
					>
						{item.year}
					</li>
				))}
			</ul>
		</div>
	);
};

export default CreationStorySlider;
